(function stateDefinition() {
    'use strict';
    angular.module('Entities')
        .service('certificateUserService', [
            'restUrlBuilder', '$injector', function certificateUserService(restUrlBuilder, $injector) {

                var restUrlBuilder = restUrlBuilder('auth');

                this.upload = function (certificate, file) {
                    if (certificate == null)
                        throw 'certificate no puede ser null';

                    var upload = $injector.get('Upload');

                    if (upload == null)
                        throw "No se pudo instanciar Upload. Verifique que se cargó el script ng-file-upload";

                    return upload.upload({
                        url: restUrlBuilder.all('certificate').url,
                        method: 'POST',
                        fields: { certificate: JSON.stringify(certificate) },
                        file: file,
                        fileFormDataName: 'certificateFile'
                    });
                };

                this.getById = function getById(certificate) {
                    var params = {
                        UserId: certificate.userId,
                        OrganizationalUnitId: certificate.organizationalUnitId,
                        Type: certificate.type,
                        NotInTree: certificate.notInTree
                    };

                    return restUrlBuilder.all('certificate').get({ params: params });
                };
            }
        ]);
})();